import React, { useContext, useEffect, useState } from "react";
import { Dialog, DynamicTable } from "../../../layout";
import { action, controller, Server } from "../../../api/Server";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocalPrintshopRounded, VisibilityRounded } from "@mui/icons-material";
import { AppContext } from "../../../App";
import MinimalPrintReceipt from "../../pos/closeRegister/MinimalPrintReceipt";
import { formatDate, PrintDiv } from "../../../hooks/Method";
import ViewClosingAccounts from "./ViewClosingAccounts";

export const RegisterClosingReport = () => {
  const { t } = useTranslation();
  const { settings, setPageTitle, pageTitle } = useContext(AppContext);
  const [reports, setReports] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [viewData, setViewData] = useState();
  const [loading, setLoading] = useState(false);
  const [viewAccounts, setViewAccounts] = useState(false);

  const handleView = (val) => {
    getDetails(val.id, () => setViewAccounts(!viewAccounts));
  };

  const getDetails = (id, onSuccess) => {
    if (id) {
      setLoading(true);
      Server(controller.Register + action.GetAccountsDetails).getById(
        id,
        (res) => {
          if (res?.status === 200) {
            setViewData(res.result);
            onSuccess && onSuccess();
          }
          setLoading(false);
        }
      );
    }
  };

  const handlePrint = (val) => {
    const onSuccess = () => {
      setTimeout(() => {
        PrintDiv("MinimalPrintReceipt");
      }, 500);
    };
    getDetails(val.id, onSuccess);
  };

  const HeaderComp = () => (
    <div className="d-flex flex-wrap g-8 w-100pr">
      <span className="border-left tx-upp fw-5 fs-18 ml-5 gray-color">
        {pageTitle}
      </span>
    </div>
  );

  useEffect(() => {
    setPageTitle(t("registerReport"));
    setTblData([
      ...reports.map((j) => ({
        ...j,
        regStatus: (
          <div className="fw-5">
            {j.status?.toLowerCase() === "open" ? (
              <span className="bg-successXS success-color pr-10 pl-10 pt-5 pb-5 br-25 fs-12 tx-upp">
                {t("open")}
              </span>
            ) : (
              <span className="bg-graySM gray-color pr-10 pl-10 pt-5 pb-5 br-25 fs-12 tx-upp">
                {t("close")}
              </span>
            )}
          </div>
        ),
        time: (
          <div className="d-grid fs-14 g-2">
            <div className="d-flex">
              <span className="tx-upp mr-10">{t("close")}:</span>
              <span className="fw-5">{formatDate(j.closeTime)}</span>
            </div>
            <div className="d-flex">
              <span className="tx-upp mr-10">{t("open")}:</span>
              <span className="fw-5">{formatDate(j.openTime)}</span>
            </div>
          </div>
        ),
        cashier: (
          <div className="d-grid fs-14 g-2">
            <div className="d-flex">
              <span className="tx-upp mr-10">{t("close")}:</span>
              <span className="fw-5">{j.closeUser || "-"}</span>
            </div>
            <div className="d-flex">
              <span className="tx-upp mr-10">{t("open")}:</span>
              <span className="fw-5">{j.openUser}</span>
            </div>
          </div>
        ),
        openTime: formatDate(j.openTime),
        closeTime: formatDate(j.closeTime),
        openCashier: j.openUser,
        closeCashier: j.closeUser,
        openingBalance: (
          <span className="fw-5">
            {settings.curSymbol}{" "}
            {(j.openingBalance || 0).toFixed(settings.decimal)}
          </span>
        ),
        totalCash: (
          <span className="fw-5">
            {settings.curSymbol}{" "}
            {(j.totalCashInDrawer || 0).toFixed(settings.decimal)}
          </span>
        ),
        totalOtherPayments: (
          <span className="fw-5">
            {settings.curSymbol}{" "}
            {(j.totalOtherPayments || 0).toFixed(settings.decimal)}
          </span>
        ),
      })),
    ]);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reports]);

  const ActionComp = (props) => (
    <div
      className="bs-secondary br-8 w-fit d-flex g-5"
      style={{ boxShadow: "var(--shadow-sm)" }}
    >
      <Tooltip arrow title={t("view")}>
        <span>
          <IconButton
            onClick={() => handleView(props)}
            size="small"
            color="primary"
            disabled={loading}
          >
            <VisibilityRounded className="fs-18 m-2" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip arrow title={t("print")}>
        <span>
          <IconButton
            onClick={() => handlePrint(props)}
            size="small"
            color="primary"
            disabled={loading}
          >
            <LocalPrintshopRounded className="fs-18 m-2" />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );

  return (
    <>
      <DynamicTable
        records={tblData}
        setRecords={setReports}
        endpointKey={controller.Register + action.GetAllByStorePg}
        exportEndpoint={controller.Register + action.ExportRegReports}
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        enableExport={true}
        enableDateRange={true}
        headers={[
          { id: "actions", label: t("actions") },
          { id: "regStatus", label: t("status") },
          { id: "id", label: t("id") },
          { id: "time", label: t("time") },
          { id: "cashier", label: t("cashier") },
          { id: "openingBalance", label: t("openingBalance") },
          { id: "totalCash", label: t("totalCash") },
          { id: "totalOtherPayments", label: t("totalOtherPayments") },
        ]}
      />

      {viewData && (
        <div className="d-none" id="MinimalPrintReceipt">
          <MinimalPrintReceipt values={viewData} />
        </div>
      )}

      {/* Edit Dialog */}
      {viewAccounts && (
        <Dialog show={viewAccounts} onClose={false}>
          <ViewClosingAccounts {...{ viewData, setViewAccounts }} />
        </Dialog>
      )}
    </>
  );
};
